import { render } from "./SearchResultView.vue?vue&type=template&id=f4a21bd0"
import script from "./SearchResultView.vue?vue&type=script&lang=js"
export * from "./SearchResultView.vue?vue&type=script&lang=js"

import "./SearchResultView.vue?vue&type=style&index=0&id=f4a21bd0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__